import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { useGetExperiment } from '../../hooks'
import { EXPERIMENT_NAME_FREE_GIFT_PROMOTION } from '../../model/EXPERIMENT_NAME_PER_TENANT'
import { EXPERIMENT_VARIATION } from '../../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../../model/Experiment.types'
import {
  experimentAccessorGetExperimentNamePerTenant,
  experimentAccessorNonDefault,
} from '../../model/experimentAccessor'

export const useGetFreeGiftPromotionsExperiment = (
  isMobile?: boolean,
): ExperimentType => {
  const { tenant } = useGlobalConfigContext()

  const experimentName = experimentAccessorGetExperimentNamePerTenant({
    experimentName: EXPERIMENT_NAME_FREE_GIFT_PROMOTION,
    isMobile,
    tenant,
  })

  return useGetExperiment(experimentName)
}

export const useIsfreeGiftPromotionsExperimentEnabledAndNotDefault = (
  isMobile?: boolean,
): boolean => {
  const freeGiftPromotionsExperiment =
    useGetFreeGiftPromotionsExperiment(isMobile)

  return experimentAccessorNonDefault(freeGiftPromotionsExperiment)
}

export const useIsfreeGiftPromotionsExperimentEnabledAndV1 = (
  isMobile?: boolean,
): boolean => {
  const { isEnabled, variant } = useGetFreeGiftPromotionsExperiment(isMobile)

  return isEnabled && variant === EXPERIMENT_VARIATION.V1
}

export const useIsfreeGiftPromotionsExperimentEnabledAndV2 = (
  isMobile?: boolean,
): boolean => {
  const { isEnabled, variant } = useGetFreeGiftPromotionsExperiment(isMobile)

  return isEnabled && variant === EXPERIMENT_VARIATION.V2
}
